import styled, { css } from "styled-components";

const columnCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #f6f6f7;

  p {
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
    color: #626262;
  }

  h2 {
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    color: #202020;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px;
`;

export const MessageContainer = styled.div`
  background-color: #0a8276;
  border-radius: 0px 0px 6px 6px;
  /* width: 230px; */

  margin: -8px auto 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`;

export const HeroContainer = styled.div`
  ${columnCenter}
  padding: 32px 24px;
  border-radius: 16px;
  background-color: #09f;
  gap: 12px;

  p {
    width: 100%;
    color: white;
  }
`;

export const Wearable = styled.div`
  margin: 24px auto;
  border-radius: 24px;
  background: #fff;

  width: 50%;
  height: 50%;
  filter: drop-shadow(4px 8px 32px rgba(0, 0, 0, 0.25));

  img {
    width: 100%;
    transform: scale(0.9);
    height: auto;
    object-fit: contain;
    aspect-ratio: 1;
  }
`;

export const BannerContainer = styled.div`
  margin: 0px auto;
  background: #fff;
  width: 100%;
  cursor: pointer;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const AfterEventContainer = styled.div`
  margin-top: -1px;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 0;
  border-radius: 16px;
  background-color: #fff;
  h2 {
    margin-top: 16px;
    line-height: 40px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 24px;
  background-color: #fff;
  border-radius: 16px;
  gap: 12px;

  a {
    font-weight: bold;
    text-decoration: underline;
    color: #626262;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    line-height: 24px;
    letter-spacing: 0.5px;
    cursor: pointer;
  }
  .emphasized {
    color: #ff6400;
  }
`;

export const AppStoreLinks = styled.section`
  img {
    cursor: pointer;
    margin-top: 24px;
    margin-right: 8px;
  }
`;

export const Footer = styled.footer`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 16px;
  margin-top: 16px;
  gap: 16px;
  .emphasized {
    color: #ff6400;
  }
  p {
    color: black;
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }

  .copyToClipboard {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  li {
    list-style: none;
  }

  .links {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .socials {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`;
